<script setup lang="ts">
const props = defineProps<{
    currentStep: number;
}>();

const { snippetT } = useSnippetT();

const steps = computed(() => [
  { id: 1, title: snippetT("checkout.steps.registration"), completed: false },
  { id: 2, title: snippetT("checkout.steps.payment"), completed: false },
  { id: 3, title: snippetT("checkout.steps.review"), completed: false },
]);

const { currentStep } = toRefs(props);
</script>
<template>
    <div class="form-step-section">
        <div class="flex items-center justify-between mx-auto relative">
            <!-- Single horizontal line that spans all steps -->
            <div class="absolute top-4 sm:top-3.5 md:top-1/2 md:-translate-y-1/2 left-0 right-0 h-[1px] sm:h-[2px] bg-primary z-0"></div>
            
            <div class="flex items-start justify-between w-full gap-0">

                <div v-for="step in steps" :key="step.id" class="flex flex-col md:flex-row items-center md:items-start group-[.active-step]:flex-[6] flex-1 group"
                :class="{ 'active-step': step.id === currentStep, 'step-done': step.id < currentStep }"
                >
                    <div class="relative flex flex-col md:flex-row items-center w-full">
                        <!-- Circle with number -->
                        <div class="w-8 h-8 sm:w-7 sm:h-7 md:w-9 md:h-9 lg:w-9 lg:h-9 xl:w-10 xl:h-10 2xl:w-12 2xl:h-12 rounded-full flex items-center justify-center border group-[.active-step]:border-primary group-[.step-done]:border-primary bg-white group-[.step-done]:bg-primary border-gray-300 z-10">
                            <h2 class="font-normal text-sm sm:text-sm md:text-base lg:text-base xl:!h5 group-[.active-step]:text-primary group-[.step-done]:text-white text-gray-300">
                                <span class="group-[.step-done]:hidden">{{ step.id }}</span>
                                <i class="icon-checkmark hidden group-[.step-done]:block"></i>
                            </h2>
                        </div>
                        
                        <!-- Mobile step title - shown below number with wrapping -->
                        <h2 class="bg-white max-w-[90px] sm:max-w-fit block md:hidden mt-1 z-10 font-medium text-sm text-center px-1 break-words group-[.active-step]:text-primary group-[.step-done]:text-primary text-gray-300">{{ step.title }}</h2>
                        
                        <!-- Desktop step title - shown to the right of number -->
                        <h2 class="bg-white max-w-[180px] sm:max-w-fit hidden md:block z-10 font-medium text-sm sm:text-sm md:text-base lg:text-base xl:!h5 px-2 sm:pl-3 md:pl-4 text-nowrap truncate group-[.active-step]:text-primary group-[.step-done]:text-primary group-[.step-done]:hidden md:group-[.step-done]:block text-gray-300">{{ step.title }}</h2>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>